import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBrain, faCalculator, faChartArea, faChartLine, faCircleQuestion, faDiceFive, faGifts, faHistory, faImages, faLanguage, faLinesLeaning, faLink, faListNumeric, faPencilRuler, faPersonArrowUpFromLine, faPersonCircleQuestion, faPersonDotsFromLine, faQuestion, faQuestionCircle, faSearch, faSheetPlastic, faSortNumericDown, faSquarePersonConfined, faTools, faTree, faVideo } from '@fortawesome/free-solid-svg-icons';
import './SmartDrill.css';
import smartdrillimage from '../../assets/pageimages/SmartDrill.webp';

function SmartDrillHome() {

  return (
    <MainLayout>
      <div className="p-4 bg-gray-100 min-h-screen mt-8">
        <h2 className='text-2xl font-bold text-center mb-4 text-gray-800'>SMARTDrills</h2>
        
        {/* Centering and Responsive Image */}
        <div className="flex justify-center mb-6">
          <img src={smartdrillimage} alt="SmartDrill" className="w-full max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md" />
        </div>

        {/* Grid Container with Mobile Padding */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mx-auto px-4">
          {/* Each Button Block */}
          {[
            { to: "/bookworld", icon: faBook, text: "Talking Books", bg: "bg-blue-400", iconColor: "text-yellow-200" },
            { to: "/orderflow-home", icon: faSheetPlastic, text: "Reusable Sheets", bg: "bg-green-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-fourlines", icon: faLinesLeaning, text: "4 Lines Writing", bg: "bg-orange-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-counting", icon: faListNumeric, text: "Counting Number", bg: "bg-red-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-numbername", icon: faSortNumericDown, text: "Number Name", bg: "bg-purple-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-numbertranslation", icon: faLanguage, text: "Number Translation", bg: "bg-teal-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-mtable", icon: faCalculator, text: "Multiplication Tables", bg: "bg-pink-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-numberbonding", icon: faLink, text: "Number Bonding", bg: "bg-indigo-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-quiz", icon: faQuestionCircle, text: "Numbers Quiz", bg: "bg-yellow-400", iconColor: "text-yellow-200" },
            { to: "/smartdrill-practicehistory", icon: faHistory, text: "Practice History", bg: "bg-blue-500", iconColor: "text-white" },
            { to: "/bigdata-home", icon: faBrain, text: "Analytics Room", bg: "bg-purple-500", iconColor: "text-white" },
            { to: "/smartdrill-ecobadge", icon: faTree, text: "Eco Badge", bg: "bg-green-500", iconColor: "text-white" },
            { to: "/smartdrill-ecoprizes", icon: faGifts, text: "Eco Prizes", bg: "bg-yellow-500", iconColor: "text-white" },
            { to: "/smartdrill-imagecloud", icon: faImages, text: "Practice Images", bg: "bg-pink-500", iconColor: "text-white" },
            { to: "/smartdrill-videocloud", icon: faVideo, text: "Practice Videos", bg: "bg-orange-500", iconColor: "text-white" },
            { to: "/smartdrill-aisettings", icon: faTools, text: "My Settings", bg: "bg-gray-500", iconColor: "text-white" },
            { to: "/smartdrill-fivewhys", icon: faSearch, text: "5Whys Analysis", bg: "bg-purple-500", iconColor: "text-white" },
            { to: "/smartdrill-about", icon: faQuestion, text: "SMART Drill", bg: "bg-indigo-500", iconColor: "text-white" }
          ].map((item, index) => (
            <div key={index} className={`flex flex-col items-center p-4 border border-gray-300 rounded-lg ${item.bg} transition-transform transform hover:scale-105`}>
              <Link to={item.to} className="text-center mb-2">
                <FontAwesomeIcon icon={item.icon} className={`text-3xl mb-2 ${item.iconColor}`} />
              </Link>
              <div className="text-white text-lg font-medium text-center">
                {item.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default SmartDrillHome;
